import get from 'lodash/get';
import { useFormContext } from 'react-hook-form';

import { ErrorMessage } from '@/components/InputErrorMessage';
import type { TextAreaProps } from '@/components/TextArea';
import { TextArea } from '@/components/TextArea';

import { Box } from './Box';

interface TextAreaFieldProps extends TextAreaProps {
  name: string;
}

export const TextAreaField = (props: TextAreaFieldProps) => {
  const { formState, register } = useFormContext();
  const labelAddition = props.required ? '*' : ``;
  const placeholder = props.placeholder
    ? `${props.placeholder}${labelAddition}`
    : undefined;
  const name = props.name;
  const error = get(formState.errors, name) as any;

  return (
    <Box>
      <TextArea
        {...props}
        {...register(name)}
        hasError={!!error}
        placeholder={placeholder}
      />
      {error && <ErrorMessage>{error.message}</ErrorMessage>}
    </Box>
  );
};

TextAreaField.displayName = 'TextAreaField';
